import store from '@/state/store';
import authenticationSlice from '@/state/authentication.slice';
import { logout } from '.';
import { loginByInvitation } from '@/api/auth';
import { initSession } from '@/loaders/profile';
import { handleError, reportError } from '../common';
import t from '@/utils/translate';

export default async (code: string): Promise<boolean> => {
  try {
    await loginByInvitation(code, logout);
    store.dispatch(authenticationSlice.actions.finishLogin());
    await initSession();
  } catch (error) {
    if (error.code === 401) {
      await logout();
      return true;
    }

    if (error.code === 403) {
      reportError(error, t('authentication.message.staleInvitation'));
      return false;
    }

    handleError(error);
  }
  return false;
};
